import { types, query, params, rawString } from 'typed-graphqlify';
import { gql } from '@apollo/client';
import { Types } from '@blumtechgroup/blum-ui-utils';

const _createClinicianUserInitQuery = (locationId: string) => ({
  locations_by_pk: params(
    { id: rawString(locationId) },
    {
      name: types.string,
      organisation: {
        name: types.string,
      },
    }
  ),
});

type X = Types.Unpacked<typeof _createClinicianUserInitQuery>;
export type Location = X['locations_by_pk'];

export const createClinicianUserInitQuery = (locationId: string) =>
  gql`
    ${query(_createClinicianUserInitQuery(locationId))}
  `;
